import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../../components/layout/AuthLayout';
import useSignupStore, { SIGNUP_STEPS } from '../../../store/useSignupStore';
import { PATHS } from '../../../routes/navConfig';
import ProfileStep from './ProfileStep';
import InterestsStep from './InterestsStep';
import KidsStep from './KidsStep';
import SchoolsStep from './SchoolsStep';
import ClassGroupStep from './ClassGroupStep';

const STEP_VIEWS = [ProfileStep, InterestsStep, KidsStep, SchoolsStep, ClassGroupStep];

/* Five-step sign-up a new account lands on straight after OTP verification.
   Nothing is written until the last step — see useSignupStore.submit. */
export default function SignupPage() {
  const step = useSignupStore((s) => s.step);
  const reset = useSignupStore((s) => s.reset);
  const navigate = useNavigate();
  const Step = STEP_VIEWS[step];

  /* Leaving the wizard (sign out, a second account on the same browser) must not
     leave someone else's half-finished draft behind. */
  useEffect(() => () => reset(), [reset]);

  const finish = () => {
    reset();
    navigate(PATHS.DASHBOARD, { replace: true });
  };

  return (
    <AuthLayout>
      <div className="ob-progress">
        {SIGNUP_STEPS.map((name, i) => (
          <span
            key={name}
            className={`ob-progress-seg ${i === step ? 'on' : ''} ${i < step ? 'done' : ''}`}
          />
        ))}
      </div>
      <Step onFinish={finish} />
    </AuthLayout>
  );
}
